var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LabelStyle, { LabelTextStyle } from './LabelStyle';
import usePassPropsToChildren from '../../utils/hooks/usePassPropsToChildren';
import LabelContext from './LabelContext';
const Label = (_a) => {
    var { children: childrenProps, label, disabled, position, noActiveState } = _a, otherProps = __rest(_a, ["children", "label", "disabled", "position", "noActiveState"]);
    const [active, setActive] = React.useState(false);
    const { children } = usePassPropsToChildren(childrenProps, {
        disabled,
    });
    const activeState = noActiveState ? false : active;
    return (React.createElement(LabelContext.Provider, { value: { active, setActive } },
        React.createElement(LabelStyle, Object.assign({}, Object.assign(Object.assign({}, otherProps), { disabled, position }), { active: activeState }),
            React.createElement(LabelTextStyle, { position: position }, label),
            children)));
};
Label.defaultProps = {
    noActiveState: false,
};
export default Label;
//# sourceMappingURL=Label.js.map